@if (!loadingData) {
  <div class="onboarding-form onboarding-form-wider">
    <div
      class="h1"
      [innerHTML]="title"></div>
    <p
      [innerHTML]="infoText"
      class="mb-lg-4"
      id="infoText"></p>

    @if (showUploadStep()) {
      <p>
        @if (checkedSmartID()) {
          <button
            class="btn-reset"
            (click)="switchIdTo('greenId', Boolean(fileFrontUrl()))">
            Upload your
            <span class="link-secondary">Green ID</span>
            instead
          </button>
        }
        @if (checkedGreenID()) {
          <button
            class="btn-reset"
            (click)="switchIdTo('smartId', Boolean(fileFrontUrl()))">
            Upload your
            <span class="link-secondary">Smart ID</span>
            instead
          </button>
        }
      </p>
    }
    @if (form) {
      <form
        class="position-relative z-3"
        [formGroup]="form"
        id="formVerifyIdentity"
        [boFormOptions]="options"
        (ngSubmit)="onSubmit()">
        <!-- Select option -->
        @if (showOptionStep()) {
          <div class="mb-3">
            @for (option of selectOptions; track option) {
              <div class="form-check input-radio-select input-radio-select-right">
                <input
                  class="form-check-input"
                  [checked]="option.checked"
                  (change)="onSelectOption(option.id)"
                  type="radio"
                  name="optionFields"
                  [id]="option.id" />
                <label
                  class="form-check-label"
                  [ngClass]="{ 'border-secondary': option.checked }"
                  [for]="option.id">
                  <i [ngClass]="option.icon"></i>
                  {{ option.label }}
                </label>
              </div>
            }
          </div>
          <app-form-field
            boFieldPath="id_number"
            [placeholder]="placeholder()"
            [inputClass]="idNumError?.length ? 'is-invalid' : ''"
            label="Identity number"></app-form-field>
          <div
            [ngClass]="{ 'd-block mt-neg-2 mb-3': idNumError?.length }"
            class="invalid-feedback"
            [innerHTML]="idNumError"></div>
        }

        <!-- Upload document -->
        @if (showUploadStep()) {
          <div class="mb-3">
            <app-upload-img-crop
              [title]="fileUploadTitle"
              text="Drag your file here or click the button below to upload"
              [width]="minWidth()"
              [height]="minHeight()"
              fieldId="frontImage"
              [destination]="destination"
              [enableBarcodeValidation]="false"
              [documentType]="checkedSmartID() ? 'id' : 'passport'"
              (imageStored)="fileFrontUploaded($event)"
              (barcodeValidationResult)="onFrontBarcodeValidationResult($event)"
              (barcodeValidationStatusChange)="onFrontBarcodeValidationStatus($event)">
            </app-upload-img-crop>
            @if (isFrontValidationInProgress()) {
              <ng-container [ngTemplateOutlet]="validatingBarcode"></ng-container>
            }
            @if (frontBarcodeValidation(); as validation) {
              @if (!validation.isValid) {
                <ng-container
                  [ngTemplateOutlet]="barcodeError"
                  [ngTemplateOutletContext]="{ validation: validation }"></ng-container>
              }
            }
          </div>
          @if (checkedSmartID()) {
            <div class="mb-3">
              <app-upload-img-crop
                title="Upload Back"
                text="Drag your file here or click the button below to upload"
                [width]="minWidth()"
                [height]="minHeight()"
                fieldId="backImage"
                [destination]="destination"
                [enableBarcodeValidation]="false"
                [documentType]="'id'"
                (imageStored)="fileBackUploaded($event)"
                (barcodeValidationResult)="onBackBarcodeValidationResult($event)"
                (barcodeValidationStatusChange)="onBackBarcodeValidationStatus($event)">
              </app-upload-img-crop>

              @if (isBackValidationInProgress()) {
                <ng-container [ngTemplateOutlet]="validatingBarcode"></ng-container>
              }
              @if (backBarcodeValidation(); as validation) {
                @if (!validation.isValid) {
                  <ng-container
                    [ngTemplateOutlet]="barcodeError"
                    [ngTemplateOutletContext]="{ validation: validation }"></ng-container>
                }
              }
            </div>
          }
        }

        <div class="row mt-4 mb-5">
          @if (showOptionStep() || showUploadStep()) {
            <div class="col-auto">
              <app-submit
                [disabled]="form.controls['id_number'].invalid || submitDisabled()"
                btnID="verifyIdentitySubmitBtn"
                btnClass="btn-lg"
                iconClass="ms-2 iconoir-arrow-right"
                [busy]="busy"
                label="Continue"></app-submit>
            </div>
          }

          @if (submissionVerified()) {
            <div class="col-auto">
              <a
                class="btn btn-primary btn-lg"
                id="btnVerifiedGoToDashboard"
                routerLink="../dashboard">
                Go to Dashboard
                <i class="ms-2 pays-icon ic-arrow-right"></i>
              </a>
            </div>
          }

          @if (showTimedOut || submissionRejected()) {
            <div class="col-auto">
              <a
                class="btn btn-outline-primary btn-lg"
                id="btnRejectedGoToDashboard"
                routerLink="../dashboard">
                Go to Dashboard
              </a>
            </div>
            <div class="col-auto">
              <a
                class="btn btn-primary btn-lg"
                id="btnContactHelpCenter"
                target="_blank"
                rel="noopener"
                [href]="helpCenterUrl">
                Contact Support
                <i class="ms-2 pays-icon ic-arrow-right"></i>
              </a>
            </div>
          }
        </div>
      </form>
    } @else {
      <app-loader></app-loader>
    }
  </div>
} @else {
  <app-loader></app-loader>
}

<ng-template #validatingBarcode>
  <div
    class="alert alert-info d-flex align-items-center mt-2"
    role="alert">
    <div class="spinner-border spinner-border-sm me-2">
      <span class="visually-hidden">Validating...</span>
    </div>
    <span>Validating ...</span>
  </div>
</ng-template>

<ng-template
  #barcodeError
  let-validation="validation">
  <div class="alert alert-danger d-flex align-items-center mt-2">
    <i class="iconoir-xmark-circle me-2"></i>
    <div>
      @if (validation.error) {
        <div class="small">
          The image does not contain a readable barcode. <br />
          Please retry with a clearer image and ensure the correct orientation.
        </div>
      }
    </div>
  </div>
</ng-template>

<app-profile-dropdown [signUpFlow]="true"></app-profile-dropdown>
